import { atom as e } from "jotai";
import { atomWithDefault as c } from "jotai/utils";
const d = e(0), o = c(
  (t) => t(d)
), n = e((t) => t(o)), r = e(
  null,
  (t, m, a) => {
    m(o, a);
  }
);
export {
  n as getSelectedRateIdAtom,
  o as selectedRateIdAtom,
  d as selectedRateIdAtomDefault,
  r as setSelectedRateIdAtom
};
